import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../api';

function InvoicePreview() {
  const { invoiceId } = useParams();
  const navigate = useNavigate();
  const [invoice, setInvoice] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchInvoice();
  }, [invoiceId]);

  const fetchInvoice = async () => {
    try {
      const response = await api.get('/api/invoices');
      
      const foundInvoice = response.data.invoices.find(inv => inv.id === parseInt(invoiceId));
      if (foundInvoice) {
        setInvoice(foundInvoice);
      }
    } catch (err) {
      console.error('Error fetching invoice:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async (format) => {
    try {
      const response = await api.get(`/api/invoices/${invoiceId}/download/${format}`, {
        responseType: 'blob'
      });

      const pipelineWarnings = response.headers['x-invoice-warnings'];
      if (pipelineWarnings) {
        try {
          const parsed = JSON.parse(pipelineWarnings);
          if (Array.isArray(parsed) && parsed.length) {
            alert(parsed.join('\n'));
          }
        } catch (_) {
          alert(pipelineWarnings);
        }
      }

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `invoice_${invoice.invoice_number}.${format}`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      console.error('Error downloading invoice:', err);
      alert('Error downloading invoice');
    }
  };

  if (loading) {
    return <div className="loading">Loading invoice...</div>;
  }

  if (!invoice) {
    return <div className="container"><div className="card">Invoice not found</div></div>;
  }

  return (
    <div>
      <header className="header">
        <div className="header-content">
          <h1>Invoice Preview</h1>
          <button className="btn btn-secondary" onClick={() => navigate('/dashboard')}>
            Back to Dashboard
          </button>
        </div>
      </header>

      <div className="container">
        <div className="card">
          <h2>Invoice #{invoice.invoice_number}</h2>
          <p>Created: {new Date(invoice.created_at).toLocaleString()}</p>
          
          <div style={{ marginTop: '20px' }}>
            <button
              className="btn btn-success"
              onClick={() => handleDownload('pdf')}
              style={{ marginRight: '10px' }}
            >
              Download PDF
            </button>
            <button
              className="btn btn-secondary"
              onClick={() => handleDownload('docx')}
            >
              Download DOCX
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InvoicePreview;

